// Client-side typeahead filtering for the /faq page. Matches the search term
// against each item's data-faq-haystack (question + seo_phrases). Semantic
// search is deferred; this is the instant text-match layer. Also reads ?q=
// from the URL so the contact page's "search the FAQ" form lands here with
// the query applied.
export function setupFaqFilter() {
  const search = document.querySelector("[data-faq-search]")
  if (!search) return

  const items = Array.from(document.querySelectorAll("[data-faq-item]"))
  const sections = Array.from(document.querySelectorAll("[data-faq-section]"))
  const groups = Array.from(document.querySelectorAll("[data-faq-section-group]"))
  const empty = document.querySelector("[data-faq-empty]")

  function apply(query) {
    const q = query.trim().toLowerCase()
    let anyVisible = false

    items.forEach((item) => {
      const match = q === "" || (item.dataset.faqHaystack || "").includes(q)
      item.hidden = !match
      if (match) anyVisible = true
      if (q !== "" && !match) item.open = false
    })
    sections.forEach((section) => {
      section.hidden = !section.querySelector("[data-faq-item]:not([hidden])")
    })
    groups.forEach((group) => {
      group.hidden = !group.querySelector("[data-faq-section]:not([hidden])")
    })
    if (empty) empty.hidden = q === "" || anyVisible
  }

  search.addEventListener("input", () => apply(search.value))

  const initial = new URLSearchParams(window.location.search).get("q")
  if (initial) {
    search.value = initial
    apply(initial)
    search.focus()
  }

  // The "by use case" lists link to #faq-<id> anchors on the accordion items
  // above. A closed <details> scrolls into view but stays closed, so open the
  // one the hash names, on load and on every in-page jump.
  function openHashTarget() {
    const id = decodeURIComponent(window.location.hash.slice(1))
    if (!id) return
    const target = document.getElementById(id)
    if (target && target.tagName === "DETAILS") target.open = true
  }
  window.addEventListener("hashchange", openHashTarget)
  openHashTarget()
}
